import axios from "axios";
import Cookies from "js-cookie";

export const axiosInstance = axios.create({
  baseURL: "https://ecommerce.customers.bigfivecrm.com",
  withCredentials: true,
});



const LOGIN_URL = "api/v2/customer/login";
const REGISTER_URL = "api/v2/customer/register";
const PRODUCTLIST_URL = "api/v2/customer/list-products";
const LOGOUT_URL = "api/v2/customer/logout";
const PROFILEVIEW_URL = "api/v2/customer/auth/profile/view";
const PROFILEDIT_URL = "api/v2/customer/auth/profile/edit";
const CHANGEPASSWORD_URL = "api/v2/customer/auth/change-password";
const FORGOT_PASSWORD = "api/v2/customer/forgot-password";
const ORDERCREATE_URL = "api/v2/customer/auth/orders/create";
const ORDERUPDATE_URL = "api/v2/customer/auth/orders/update";
const ORDERVIEW_URL = "api/v2/customer/auth/orders/view";
const CHECKOUT_URL ="api/v2/customer/auth/orders/checkout";
const WEBDATA_URL = "api/v2/webdata";



/**
 * Login API - Authenticate user and store token in cookies
 */
export const LoginAPI = async (data) => {
  try {
    const response = await axiosInstance.post(LOGIN_URL, data);

    return response.data;
  } catch (error) {
    console.error("Login failed:", error.response?.data || error.message);
    throw error;
  }
};


export const LogOutApi = async () => {
    const response = await axiosInstance.post(LOGOUT_URL);     
    
}
/**
 * Register API - Create a new user
 */
export const RegisterAPI = async (data) => {
  try {
    const response = await axiosInstance.post(REGISTER_URL, data);
    return response.data;
  } catch (error) {
    console.error("Register failed:", error.response?.data || error.message);
    throw error;
  }
};

/**
 * Fetch Product List - No Authorization needed
 */
export const ProductListAPI = async (data) => {
  try {
    const response = await axiosInstance.post(PRODUCTLIST_URL, data, {
      headers: {
        Authorization: undefined, // Explicitly remove Authorization header
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Fetching products failed:",
      error.response?.data || error.message
    );
    throw error;
  }
};

/**
 * Profile view - Create a new user
 */

export const ProfileView = async () => {
    try {
      const response = await axiosInstance.post(PROFILEVIEW_URL);
      return response.data;
    } catch (error) {
      console.error("Register failed:", error.response?.data || error.message);
      throw error;
    }
  };

  /**
 * Profile Edit Api
 */
export const ProfileEditApi = async (data) => {
    try {
      const response = await axiosInstance.post(PROFILEDIT_URL, data);
      return response.data;
    } catch (error) {
      console.error("Register failed:", error.response?.data || error.message);
      throw error;
    }
  };


  /**
 *Change passwordapi
 */
  export const ChangePasswordApi = (values) => {
 
 
    return  axiosInstance.post(CHANGEPASSWORD_URL,values)
        .then(response => {
            return response;
        })
        .catch(error => { 
  
            console.error('Error during ChangePasswordApi:', error);
            throw error;
        });
  }

  //////// forgot password


  export const ForgotPassword = (values) => {
   
    return axiosInstance.post(FORGOT_PASSWORD,values)
        .then(response => {
            return response;
        })
        .catch(error => {
            console.error('Error during ForgotPassword:', error);
            throw error;
        });
}

///reset api

export const ResetPasswordApi = (values,token) => {
   
  
    return axiosInstance.post(`/api/v2/customer/reset-password/${token}`,values)
        .then(response => {
            return response;
        })
        .catch(error => {
            console.error('Error during ChangePasswordApi:', error);
            throw error;
        });
  }


  //////order Create Api
  export const OrderCreateApi = async (data) => {
    try {
      const response = await axiosInstance.post(ORDERCREATE_URL, data);
      return response.data;
    } catch (error) {
      console.error("Order Creation Failed", error.response?.data || error.message);
      throw error;
    }
  };

  /////order update api

  export const OrderUpdateApi = async (data) => {
    try {
      const response = await axiosInstance.post(ORDERUPDATE_URL, data);
      return response.data;
    } catch (error) {
      console.error("Order Updation Failed", error.response?.data || error.message);
      throw error;
    }
  };

  ////order View api

  export const OrderViewApi = async () => {
    try {
      const response = await axiosInstance.post(ORDERVIEW_URL);
      return response.data;
    } catch (error) {
      console.error("Order Updation Failed", error.response?.data || error.message);
      throw error;
    }
  };

   ////order History api

   export const OrderHistoryApi = async (data) => {
    try {
      const response = await axiosInstance.post(ORDERVIEW_URL, data);
      return response.data;
    } catch (error) {
      console.error("Order History Failed", error.response?.data || error.message);
      throw error;
    }
  };

  ///// order checkout api

  export const CheckOutApi = async (data) => {
    try {
      const response = await axiosInstance.post(CHECKOUT_URL, data);
      return response.data;
    } catch (error) {
      console.error("Check out failed", error.response?.data || error.message);
      throw error;
    }
  };


  /////////form submit api
  export const SubmitFormAPI = async (data) => {
    try {
      const response = await axiosInstance.post(WEBDATA_URL, data);
      return response.data;
    } catch (error) {
      console.error("Form Submit failed", error.response?.data || error.message);
      throw error;
    }
  };